module.exports = __webpack_public_path__ + "static/media/ba.010ce0ad.svg";